<template>
  <auth-page>
    <h2 class="brand-text">Reset Password</h2>
    <p>for {{ fields.email }}</p>
    <b-form v-if="!success" @submit="onSubmit">
      <b-form-group>
        <label class="sr-only" for="password-input">Password</label>
        <input
          v-validate="'required|min:8|lowercase|uppercase|numberOrSpecial'"
          id="password-input"
          ref="password"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password') || apiErrors.password.length}"
          class="form-control"
          type="password"
          name="password"
          placeholder="Password"
          @input="setPassword"/>
        <validation-errors :validation-errors="[errors.first('password')]"/>
        <span v-if="!errors.has('password')">
          <validation-errors :validation-errors="apiErrors.password"/>
        </span>
      </b-form-group>
      <b-form-group>
        <label class="sr-only" for="password-confirm">Confirm Password</label>
        <input
          v-validate="'required|confirmed:password'"
          id="password-confirm"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('password-confirm') }"
          class="form-control"
          type="password"
          name="password-confirm"
          data-vv-as="password"
          placeholder="Confirm Password"/>
        <validation-errors :validation-errors="[errors.first('password-confirm')]"/>
      </b-form-group>
      <b-tooltip target="password-input" triggers="focus" placement="left">
        <password-rules/>
      </b-tooltip>
      <b-form-group>
        <b-button :disabled="disabled" type="submit" block variant="light">
          Submit
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>
      <form-fail :form-errors="apiErrors.other"/>
    </b-form>
    <form-success :success="success">
      Your password has been reset.
      <br>
      You may now use it to
      <router-link :to="{name: 'login', query: {email: fields.email}}" style="text-decoration:underline">login</router-link>
    </form-success>
    <router-link :to="{name: 'login'}" class="link-light">
      <i class="fas fa-hand-point-left"></i>
      &nbsp;back to login
    </router-link>
  </auth-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import authPage from '../../templates/auth-page'
import formFail from '../../common/form/form-fail'
import passwordRules from '../../common/form/password-rules'
import dynamicInput from '../../common/form/input'
import validationErrors from '../../common/form/validation-errors'
import formSuccess from '../../common/form/form-success'

export default {
  components: {
    authPage,
    formFail,
    passwordRules,
    dynamicInput,
    validationErrors,
    formSuccess
  },
  computed: {
    ...mapState('register/forms/resetPassword', [
      'apiErrors',
      'success',
      'fields',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  created () {
    if (this.$route.params.token) {
      this.$store.commit('register/forms/resetPassword/setField', {
        field: 'token',
        value: this.$route.params.token
      })
    }

    if (this.$route.query.email) {
      this.$store.commit('register/forms/resetPassword/setField', {
        field: 'email',
        value: this.$route.query.email
      })
    }
  },
  methods: {
    ...mapActions({
      resetPassword: 'register/resetPassword'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.resetPassword()
        }
      })
    },
    setPassword (e) {
      this.$store.commit('register/forms/resetPassword/setField', {
        field: 'password',
        value: e.target.value
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/reset-password.vue